import commonModule from "./tw/common";
import userModule from "./tw/user";
import loginModule from "./tw/login";
import registerModule from "./tw/register";
import questionModule from "./tw/question";
import statusModule from "./tw/status";
import codeModule from "./tw/errorCode";
import { storeModule, evaluationModule } from "./tw/store";
import { orderModule } from "./tw/order";
import { homeModule, searchModule } from "./tw/home";
import { otherModule } from "./tw/other";
const zh_f = {
  commonBox: commonModule,
  loginBox: loginModule,
  registerBox: registerModule,
  questionBox: questionModule,
  //店铺详情
  storeDetail: storeModule,
  //评价部分
  evaluationBox: evaluationModule,
  orderModule: orderModule,
  //首页
  home: homeModule,
  searchModule: searchModule,
  userModule: userModule,
  //状态
  status: statusModule,
  //错误码
  errorCode: codeModule,
  //其它
  otherModule: otherModule
};
export default zh_f;
